import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4AA4E035-3A6F-40FA-8355-A38F9294E399
 * name music-accidental-natural
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-accidental-natural.svg
 * tags
 * - Music 
 */
export const MusicAccidentalNaturalIcon = createSvgIcon(<><path d="M10 8.75V3.5H8V17.5L14 15.25V20.5H16V6.5L10 8.75M14 13.25L10 14.75V10.75L14 9.25V13.25Z" /></>, 'MusicAccidentalNaturalIcon');
export default MusicAccidentalNaturalIcon